<!--
 * @Author: Ashley.Liu
 * @Date: 2022-06-12 16:15:43
 * @LastEditTime: 2022-12-16 17:11:49
 * @Description: desc
-->
<template>
  <div
    class="as-menu"
    :style="menuStyle"
    v-resize.collapse.enter="handleResize"
  >
    <div
      class="flex-row flex-ai-center flex-jc-center"
      v-if="!isCollapse && hasTab"
    >
      <zm-tabs type="pipeline" v-model="activeMenuTab" stretch>
        <zm-tab-pane
          v-for="tab in tabList"
          :key="tab"
          :label="tab"
          :name="tab"
        />
      </zm-tabs>
    </div>

    <zm-scrollbar>
      <div class="menu-box">
        <div
          class="flex-row flex-ai-center flex-jc-center mgb-sm"
          v-if="canSearch"
          v-show="!isCollapse"
        >
          <zm-input
            v-model="menuSearch"
            style="width: 86%"
            placeholder="search menu"
            @input="filterMenu"
            clearable
          >
            <i
              class="zm-icon-search mgl-sm"
              slot="prefix"
              @click.prevent.stop="filterMenu"
            ></i>
          </zm-input>
        </div>

        <zm-menu
          ref="menuRef"
          :collapse.sync="isCollapse"
          :default-active="defaultActive"
          :default-openeds="defaultOpens"
          :style="{ width: isCollapse ? 'fix-content' : menuWidth }"
          @close="closeMenu"
          :collapse-transition="false"
          :router="router"
          v-bind="$attrs"
          v-on="$listeners"
        >
          <template v-for="menu in menuList">
            <MenuItem
              v-if="!menu.children"
              :menuItem="menu"
              :key="menu.index"
              :isFirst="true"
              :collapse="isCollapse"
              itemStyle="padding-left: 8px;"
            >
            </MenuItem>
            <zm-submenu :index="menu.index" :key="menu.index" v-else>
              <template slot="title">
                <i :class="isCollapse ? menu.icon : 'zm-icon-right'" />
                <div style="display: inline-block:" v-if="!isCollapse">
                  {{ menu.name }}
                </div>
                <!--- pin --->
                <div
                  v-if="!isCollapse"
                  :class="
                    !pinCache.has(menu.index, pins) ? 'hover-display-pin' : ''
                  "
                >
                  <i
                    class="iconfont icon-a-pin mgl-sm"
                    @click.prevent.stop="
                      setPin(
                        menu.index,
                        !pinCache.has(menu.index, pins) ? '' : 'delete'
                      )
                    "
                    :style="
                      !pinCache.has(menu.index, pins) ? '' : 'color: #0e71eb'
                    "
                  ></i>
                </div>
              </template>
              <!--- group --->
              <template v-for="child in menu.children">
                <MenuItem
                  v-if="!child.children"
                  :menuItem="child"
                  :key="child.index"
                  :collapse="isCollapse"
                >
                </MenuItem>
                <zm-menu-item-group :key="child.index" v-else>
                  <span slot="title">{{ child.name }}</span>
                  <MenuItem
                    v-for="childItem in child.children"
                    :key="childItem.index"
                    :menuItem="childItem"
                    :collapse="isCollapse"
                    itemStyle="padding-left: 16px"
                  >
                  </MenuItem>
                </zm-menu-item-group>
              </template>
            </zm-submenu>
          </template>
        </zm-menu>
        <div
          v-if="!menuList.length && menuList_copy && menuList_copy.length"
          class="no-data"
        >
          no matched results
        </div>
      </div>
    </zm-scrollbar>
  </div>
</template>
<script>
import { debounce, pinCache, deepMap } from '../../utils'
import cloneDeep from 'lodash/cloneDeep'
import MenuItem from './MenuItem.vue'
import resize from '../../directives/resize'
export default {
  name: 'AsMenu',
  components: {
    MenuItem,
  },
  directives: {
    [resize.name]: resize,
  },
  props: {
    width: {
      type: Number,
      default: 240,
    },
    height: {
      type: [String, Number],
      default: '100%',
    },
    tabList: {
      type: Array,
      default: () => [],
    },
    canSearch: {
      type: Boolean,
      default: true,
    },
    menuConfig: {
      type: [Array, Object],
      default: () => [],
    },
    activeAll: {
      type: Boolean,
      default: false,
    },
    router: {
      type: Boolean,
      default: false,
    },
    showCollapse: {
      type: Boolean,
      default: true,
    },
    activeTab: {
      type: String,
      default: '',
    },
    defaultActive: {
      type: String,
      default: '',
    },
  },
  computed: {
    hasTab() {
      return this.tabList?.length
    },
    menuList_copy() {
      if (this.hasTab) {
        return cloneDeep(this.menuConfig[this.activeMenuTab])
      } else {
        return cloneDeep(this.menuConfig)
      }
    },
    menuStyle() {
      return {
        width: this.isCollapse ? 'fit-content' : `${this.width}px`,
        height: this.height,
      }
    },
  },
  data() {
    return {
      menuList: [],
      menuSearch: '',
      pinCache: pinCache,
      pins: [],
      defaultOpens: [],
      isCollapse: false,
      activeMenuTab: '',
      menuWidth: this.width - 20 + 'px',
    }
  },
  watch: {
    activeTab(v) {
      this.activeMenuTab = v
    },
    activeMenuTab(v) {
      this.getMenuList()
      this.$emit('update:activeTab', v)
    },
    menuConfig: {
      deep: true,
      handler() {
        this.getMenuList()
      },
    },
  },
  created() {
    if (this.hasTab) {
      this.activeMenuTab = this.activeTab || this.tabList?.[0] || ''
    }
    this.getMenuList()
    if (this.activeAll) {
      this.defaultOpens = deepMap([], this.menuList)
    } else {
      this.defaultOpens = this.pins = pinCache.getPins()
    }
  },
  methods: {
    getMenuList() {
      this.menuList = cloneDeep(this.menuList_copy)
      this.menuList = this.menuList.map((m) => {
        m.pin = pinCache.has(m.index)
        return m
      })
    },
    filterMenu: debounce(function () {
      const tempList = cloneDeep(this.menuList_copy)
      if (!this.menuSearch) return (this.menuList = tempList)
      this.menuList = tempList.filter((menu) => {
        return this.findChilds(menu)
      })
      if (this.menuList.length) {
        this.defaultOpens = deepMap([], this.menuList)
      }
    }, 200),
    findChilds(child) {
      if (this.includes(child.name)) {
        return true
      }
      if (!child.children?.length) {
        return false
      }
      child.children = child.children.filter((item) => {
        return this.findChilds(item)
      })
      return !!child.children?.length
    },
    includes(item) {
      return item
        .toLocaleLowerCase()
        .includes(this.menuSearch.toLocaleLowerCase())
    },
    setPin(index, isDelete) {
      if (isDelete) {
        this.pins = pinCache.deletePin(index)
        return
      }
      this.pins = pinCache.setPins(index)
      this.$refs.menuRef.open(index)
    },
    closeMenu(menu) {
      if (this.pins.includes(menu)) {
        this.$confirm(
          'The current menu was pinned, do you want to cancel it?',
          'Hint',
          {
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            closeOnClickModal: true,
          }
        )
          .then(() => {
            this.setPin(menu, 'delete')
          })
          .catch(() => {
            this.$refs.menuRef.open(menu)
          })
      }
    },
    handleResize() {
      if (arguments[0] !== undefined && typeof arguments[0] === 'boolean') {
        this.isCollapse = arguments[0]
        if (this.isCollapse) {
          this.menuWidth = '60px'
        } else {
          this.menuWidth = this.width - 20 + 'px'
        }
        this.$emit('collapse', this.isCollapse)
        return
      }
      if (typeof arguments[0] === 'number') {
        const resizeLength = arguments[0]
        this.menuWidth = resizeLength - 20 + 'px'
        if (resizeLength < 120) {
          this.isCollapse = true
        } else {
          this.isCollapse = false
        }
        this.$emit('resize', resizeLength)
      }
    },
  },
}
</script>
<style lang="scss">
@import '../../../assets/fonts/iconfont.css';
@import '../../styles/common.scss';
@mixin menu-style {
  .zm-menu-item {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    color: #131619;
    min-width: 50px;
    border-radius: 8px;
    box-sizing: border-box;
    height: 39px;
    margin: 5px;
    span {
      font-size: 16px;
    }
    &.is-active {
      .nav-item,
      .nav-item a {
        color: #ffffff;
      }
      background: #0e72ed;
      [class^='zm-icon-'],
      [class^='iconfont'] {
        color: #fff;
      }
    }
  }
  .zm-menu-item-group__title {
    color: #81878c;
    font-weight: 400;
    font-size: 16px;
    line-height: 21px;
    margin: 5px;
    span {
      font-size: 16px;
    }
  }
  .zm-submenu__title {
    height: 39px;
    margin: 9px 5px 0 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    color: #131619;
    text-decoration: none;
    padding-left: 8px !important;
    span {
      font-size: 16px;
    }
    .hover-display-pin {
      display: none;
    }

    &:hover {
      .hover-display-pin {
        display: inherit;
      }
    }
  }
}

.as-menu {
  background: #f7f7fa;
  position: relative;
  overflow-y: hidden;
  overflow-x: hidden;
  box-sizing: border-box;
  overflow-x: hidden;
  padding-top: 12px;
  will-change: width;
  .as-menu {
    padding-top: 0;
  }

  .zm-button--icon {
    background: #fff;
  }

  .zm-scrollbar {
    height: 100%;
    padding-bottom: 60px;
  }

  .zm-scrollbar__wrap {
    overflow-y: scroll;
    overflow-x: hidden;
    height: 100%;
  }
  .zm-tabs {
    .zm-tabs__header {
      width: 100%;
    }
    &.zm-tabs--pipeline > .zm-tabs__header .zm-tabs__item {
      font-size: 16px;
    }
  }
  .menu-box {
    padding: 6px 0 60px 0;
    position: relative;
    .zm-input__inner {
      font-size: 16px;
    }
  }

  .zm-menu {
    background: #f7f7fa;
    border-right: none;

    .zm-menu--inline {
      margin-left: 12px;
    }
    @include menu-style;
    .zm-submenu [class*=' zm-icon-'],
    .zm-submenu [class^='zm-icon-'],
    .zm-menu-item [class^='zm-icon-'],
    .zm-menu-item [class^='iconfont'] {
      color: #6e7680;
      font-size: 18px;
      margin-right: 0;
      width: 28px;
      text-align: center;
    }

    .zm-submenu__icon-arrow {
      display: none;
    }

    .is-opened {
      > .zm-submenu__title .zm-icon-right {
        transform: rotateZ(90deg);
      }
    }
  }

  .no-data {
    text-align: center;
    color: #6e7680;
  }

  .collapse-button {
    position: absolute;
    bottom: 0;
    width: 100%;
    border-radius: 50%;
    text-align: center;
    height: 60px;
    font-size: 16px;
    line-height: 24px;
    color: #141414;
    background: inherit;
    border-top: 1px solid #ededf4;
    border-right: none;
    border-bottom: none;
    border-left: none;

    & .zm-button__slot {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    &.collapse {
      width: 64px;
    }
  }
}

.zm-menu--vertical {
  left: 60px !important;
  .zm-menu--popup {
    padding: 8px;
  }
  @include menu-style;
}
</style>
